import api from '../utils/api';

// Fetch all teacher-student associations
export const getTeacherStudents = async (headers) => {
  try {
    const response = await api.get('/api/teacherStudents',  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching all teacher-student associations:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific teacher-student association by ID
export const getTeacherStudentById = async (id, headers) => {
  try {
    const response = await api.get(`/api/teacherStudents/${id}`,  headers );
    console.log('Fetched teacher-student association:', response.data); // Debugging statement
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher-student association by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new teacher-student association
export const createTeacherStudent = async (teacherStudentData, headers) => {
  try {
    const response = await api.post('/api/teacherStudents', teacherStudentData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating teacher-student association:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing teacher-student association
export const updateTeacherStudent = async (id, teacherStudentData, headers) => {
  try {
    const response = await api.put(`/api/teacherStudents/${id}`, teacherStudentData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating teacher-student association:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a teacher-student association
export const deleteTeacherStudent = async (id, headers) => {
  try {
    const response = await api.delete(`/api/teacherStudent/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error deleting teacher-student association:', error.response ? error.response.data : error.message);
    throw error;
  }
};
